import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useCompany } from "../context/CompanyContext";

export default function RequireAdminRole({ children }) {
  const { companyRole, businessRole, plan } = useCompany();
  const location = useLocation();

  if (companyRole == null) {
    return <div style={{ padding: 16 }}>Loading…</div>;
  }

  const allowed =
    plan === "business"
      ? businessRole === "superadmin"
      : companyRole === "admin";

  if (!allowed) {
    return <Navigate to="/dashboard" replace state={{ from: location }} />;
  }

  return children;
}
